import { TabList, Tabs, Tab, TabPanel, Text } from "@certn/cascadia-react";
import { useTranslation, Trans } from "react-i18next";

import { usePermissions } from "../../../components/permissions/PermissionsProvider";
import { AtsIntegrationList } from "../../ats-integrations/AtsIntegrationList";

const NoIntegrations = () => (
  <Text>
    <Trans>No API integrations found - please contact support.</Trans>
  </Text>
);

export function NoAPIConfiguration() {
  const { t } = useTranslation();

  const { hasPermission } = usePermissions();
  const canConfigureAts = hasPermission({
    action: "configure",
    target: "ats_integration",
    scope: "all",
  });

  if (!canConfigureAts) {
    return <NoIntegrations />;
  }

  return (
    <Tabs gap="space-4" testID="no-api-configuration-tabs">
      <TabList aria-label={t("Integration settings")}>
        <Tab id="ats-integrations" testID="ats-integrations-tab">
          <Trans>ATS Integrations</Trans>
        </Tab>
        <Tab id="api-keys" testID="api-keys-tab">
          <Trans>API Keys</Trans>
        </Tab>
        <Tab id="webhooks" testID="webhooks-tab">
          <Trans>Webhooks</Trans>
        </Tab>
        <Tab id="documentation" testID="documentation-tab">
          <Trans>Documentation</Trans>
        </Tab>
      </TabList>
      <TabPanel id="ats-integrations">
        <AtsIntegrationList />
      </TabPanel>
      <TabPanel id="api-keys">
        <NoIntegrations />
      </TabPanel>
      <TabPanel id="webhooks">
        <NoIntegrations />
      </TabPanel>
      <TabPanel id="documentation">
        <NoIntegrations />
      </TabPanel>
    </Tabs>
  );
}
